export const passwordHint = 'Password must contain at least 8 characters'
